import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface ImportPreflightRequestOptions {
	readonly collectionId: string | undefined;
	readonly requestModel: ImportPreflightRequestModel;
}

export interface ImportPreflightRequestModel {
	readonly headers: string;
}

export interface ImportPreflightResponseModel {
	readonly csvImportToken: string;
}

export const useImportPreflight = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<ImportPreflightResponseModel>, ImportPreflightRequestOptions> = options => {
		return http<ImportPreflightResponseModel, ImportPreflightRequestModel>({
			method: "POST",
			url: options.collectionId ? `/collection/${options.collectionId}/import` : "/import",
			body: options.requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
